var map = {
	"./aircon-truck.png": 1380,
	"./aircraft.png": 1381,
	"./airstarter.png": 1382,
	"./airtug.png": 1383,
	"./ambulance.png": 1384,
	"./bed.png": 1385,
	"./bicycle.png": 1386,
	"./boom-lift.png": 1387,
	"./bowser.png": 1388,
	"./boy.png": 1389,
	"./bulldozer.png": 1390,
	"./bus.png": 1391,
	"./car.png": 1392,
	"./catering-hi-lift.png": 1393,
	"./cement-mixer.png": 1394,
	"./crane.png": 1395,
	"./defueller.png": 1396,
	"./dispenser.png": 1397,
	"./excavator.png": 1398,
	"./female.png": 1399,
	"./fire-tender.png": 1400,
	"./forklift.png": 1401,
	"./galley-cart.png": 1402,
	"./garbage-wagon.png": 1403,
	"./girl.png": 1404,
	"./helmet.png": 1405,
	"./infant.png": 1406,
	"./invalid-passenger-lift.png": 1407,
	"./joint-pallet-container-loader.png": 1408,
	"./lavatory-truck.png": 1409,
	"./lorry.png": 1410,
	"./main-deck-loader.png": 1411,
	"./maintenance-platform.png": 1412,
	"./male.png": 1413,
	"./mechanical-sweeper.png": 1414,
	"./mini-bus.png": 1415,
	"./mobile-gpu.png": 1416,
	"./motorcycle.png": 1417,
	"./others.png": 1418,
	"./passenger-step.png": 1419,
	"./pmd.png": 1420,
	"./police-car.png": 1421,
	"./prime-mover.png": 1422,
	"./recovery-truck.png": 1423,
	"./scissor-lift.png": 1424,
	"./scooter.png": 1425,
	"./scrubber.png": 1426,
	"./seatbelt.png": 1427,
	"./ship.png": 1428,
	"./skyloader.png": 1429,
	"./storage-bin.png": 1430,
	"./tanker.png": 1431,
	"./tm-compressor.png": 1432,
	"./tm-gpu.png": 1433,
	"./towed-skyloader.png": 1434,
	"./tractor.png": 1435,
	"./trailer.png": 1436,
	"./tram.png": 1437,
	"./transporter.png": 1438,
	"./van.png": 1439,
	"./water-truck.png": 1440
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1379;